//全屏混入
import screenfull from 'screenfull';
export default{
  data(){
    return {
      isScreenfull:false,
    };
  },
  created(){
    screenfull.on('change',()=>{
      this.isScreenfull=screenfull.isFullscreen;
    });
  },
  beforeDestroy(){
    screenfull.off('change');
  },
  methods:{
    //切换dom全屏状态
    toggleScreen(el){
      screenfull.toggle(el);
    },
  },
}
